import { useLocation } from "react-router-dom";
import { BsArrowsAngleExpand } from "react-icons/bs";
import { useAppNavigate, useAppSelector, useIconSize } from "@app/hooks";
import { selectCurrentProject } from "@features/project/projectSlice";
import TranslatableText from "@components/translations/TranslatableText";
import Button from "@components/button/Button";

const OpenMapButton = ({ mode = "project" }: { mode?: "baseline" | "project" }) => {
  const iconSize = useIconSize(14);
  const navigate = useAppNavigate();
  const { project } = useAppSelector(selectCurrentProject);
  const { pathname } = useLocation();

  const handleClick = () => {
    if (project?.id) {
      const path = mode === "baseline"
        ? `/bintact-builder/${project.id}?mode=baseline`
        : `/bintact-builder/${project.id}`;
      navigate({ path, options: { state: { from: pathname } } });
    }
  };

  return (
    <div
      className={`open-map-button open-map-button--${mode} mt-1`}
      onClick={handleClick}
    >
      <Button whileHoverProps={{ scale: 1.05 }} className="w-100">
        <BsArrowsAngleExpand size={iconSize} color="var(--white)" />
        <TranslatableText
          translationKey={mode === "baseline" ? "map.open_baseline_map" : "map.open_project_map"}
          className="fs-12 ff-bold"
        />
      </Button>
    </div>
  );
};

export default OpenMapButton;
